import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/decorations/house.svg'
import _imports_1 from '@/assets/images/decorations/dot-arrow.svg'
import _imports_2 from '@/assets/images/decorations/hospital.svg'
import _imports_3 from '@/assets/icons/pc.svg'
import _imports_4 from '@/assets/icons/form.svg'
import _imports_5 from '@/assets/icons/help.svg'


const _hoisted_1 = { class: "section-how-it-works" }
const _hoisted_2 = { class: "section-how-it-works__header" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "section-how-it-works__content" }
const _hoisted_5 = { class: "illustration" }
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<div class=\"illustration__item\"><img src=\"" + _imports_0 + "\" alt=\"house\"></div><div class=\"illustration__item\"><img class=\"arrow\" src=\"" + _imports_1 + "\" alt=\"asset\"><img class=\"arrow\" src=\"" + _imports_1 + "\" alt=\"asset\"></div><div class=\"illustration__item\"><img src=\"" + _imports_2 + "\" alt=\"hospital\"></div>", 3)
const _hoisted_9 = {
  ref: "pcTile",
  class: "illustration__item illustration__item--particle"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: "asset"
}, null, -1)
const _hoisted_11 = {
  ref: "formTile",
  class: "illustration__item illustration__item--particle"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: "asset"
}, null, -1)
const _hoisted_13 = {
  ref: "helpTile",
  class: "illustration__item illustration__item--particle"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  alt: "asset"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiTile = _resolveComponent("UiTile")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.dict.title), 1),
      _createElementVNode("p", null, [
        _createTextVNode(_toDisplayString(_ctx.dict.description) + " ", 1),
        _hoisted_3,
        _createElementVNode("strong", null, _toDisplayString(_ctx.dict.recap), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_UiTile, null, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_UiTile, null, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ], 512),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_UiTile, null, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          })
        ], 512)
      ])
    ])
  ]))
}